import React from 'react';

interface IProps {
    active?: boolean;
    width?: string;
    height?: string;
}
export const People: React.FC<IProps> = ({ active, height, width }) => {
    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m30 30h115.007812v-30h-145.007812v145.007812h30zm0 0" />
            <path d="m366.992188 0v30h115.007812v115.007812h30v-145.007812zm0 0" />
            <path d="m30 366.992188h-30v145.007812h145.007812v-30h-115.007812zm0 0" />
            <path d="m482 482h-115.007812v30h145.007812v-145.007812h-30zm0 0" />
            <path d="m187.675781 269.515625c-61.226562 19.636719-105.675781 77.105469-105.675781 144.769531v15h346v-15c0-67.601562-44.367188-125.027344-105.507812-144.714844 26.523437-20.308593 43.664062-52.285156 43.664062-88.195312 0-61.226562-49.808594-111.035156-111.035156-111.035156-61.226563 0-111.035156 49.808594-111.035156 111.035156 0 35.878906 17.109374 67.828125 43.589843 88.140625zm88.328125 22.773437c62.191406 0 113.660156 46.78125 121.078125 106.996094h-284.164062c7.417969-60.214844 58.890625-106.996094 121.078125-106.996094zm-20.882812-191.949218c44.683594 0 81.035156 36.351562 81.035156 81.035156 0 43.222656-34.015625 78.644531-76.683594 80.914062h-8.707031c-42.664063-2.269531-76.679687-37.691406-76.679687-80.914062 0-44.683594 36.351562-81.035156 81.035156-81.035156zm0 0" />
        </svg>
    );
};
